import { ApiFunc, getInstance } from '@src/helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const paymentsPrincipal: ApiFunc<`${typeof API.STUDENT_PAYMENTS_PRINCIPAL}`, 'get'> = params =>
  instance.get(API.STUDENT_PAYMENTS_PRINCIPAL, {
    params,
  })

export const paymentsByStudent: ApiFunc<`${typeof API.STUDENT_PAYMENTS_BY_STUDENT}`, 'get'> = params =>
  instance.get(API.STUDENT_PAYMENTS_BY_STUDENT, {
    params,
  })

export const paymentsCreate: ApiFunc<`${typeof API.STUDENT_PAYMENTS}`, 'post'> = data =>
  instance.post(API.STUDENT_PAYMENTS, data)

export const oneCContracts: ApiFunc<`${typeof API.ONE_C_CONTRACTS}`, 'get'> = params =>
  instance.get(API.ONE_C_CONTRACTS, {
    params,
  })

export const oneCContractsStudent: ApiFunc<`${typeof API.ONE_C_CONTRACTS_STUDENT}`, 'get'> = params =>
  instance.get(API.ONE_C_CONTRACTS_STUDENT, { params })

export const oneCSalaryStaff: ApiFunc<`${typeof API.ONE_C_SALARY_STAFF}`, 'get'> = params =>
  instance.get(API.ONE_C_SALARY_STAFF, { params })
